import React, { useId } from 'react';
import { Rect } from 'react-native-svg';
import { IconWithGradient } from 'design-system/icons/Icon';
export const IconFourBars = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} defaultGradientKey={'brandGradient'} {...props}>
      <Rect x="2.58984" y="13.668" width="2.83" height="6.66667" rx="1.415" fill={`url(#gradient_${id})`}/>
      <Rect x="7.91992" y="7.83203" width="2.83" height="12.5" rx="1.415" fill={`url(#gradient_${id})`}/>
      <Rect x="18.5801" y="7.83203" width="2.83" height="12.5" rx="1.415" fill={`url(#gradient_${id})`}/>
      <Rect x="13.25" y="3.66797" width="2.83" height="16.6667" rx="1.415" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
